import React, { useState, useRef } from "react";
import IdleTimer from "react-idle-timer";
import { Session } from "@collectivehealth/cog";
import { minutesToMilliseconds } from "utils/session";
import Modal from "components/Modal";
import RenderIf from "components/RenderIf";

const IDLE_TIMEOUT = minutesToMilliseconds(9);
const LOGOUT_TIMEOUT = minutesToMilliseconds(1);

export default function SessionTimeout() {
  const logoutTimerRef = useRef();
  const [showIdleModal, setShowIdleModal] = useState(false);
  const [secondsToLogout, setSecondsToLogout] = useState(60);
  const [intervalId, setIntervalId] = useState();

  function cancelInterval() {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(false);
    }
  }

  function showModal() {
    cancelInterval();
    setShowIdleModal(true);
    setIntervalId(
      setInterval(() => {
        if (logoutTimerRef.current) {
          setSecondsToLogout(Math.floor(logoutTimerRef.current.getRemainingTime() / 1000));
        }
      }, 500)
    );
  }

  function hideModal() {
    cancelInterval();
    setShowIdleModal(false);
    setSecondsToLogout(60);
  }

  return (
    <>
      <IdleTimer timeout={IDLE_TIMEOUT} onIdle={showModal} onActive={hideModal} />
      <RenderIf
        test={showIdleModal}
        renderer={() => (
          <IdleTimer
            timeout={LOGOUT_TIMEOUT}
            ref={logoutTimerRef}
            onIdle={() => Session.endSession()}
          />
        )}
      />
      <Modal
        isOpen={showIdleModal}
        header="Your session is about to expire due to inactivity"
        body={`You will be logged out in ${secondsToLogout} seconds`}
      ></Modal>
    </>
  );
}
